import { useEffect } from "react";

import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import DynamicForm from "../../../../../components/modules/ClientDetail/Case/DynamicForm";
import InvalidContent from "../../../../../components/modules/ClientDetail/Case/DynamicForm/components/InvalidContent";
import { mapPermissions } from "../../../../../components/modules/ClientDetail/Case/utils/functions";
import { propertyDamageLayout } from "../../../../../components/modules/ClientDetail/Case/utils/layouts";
import { propertyDamageTabDataMapper } from "../../../../../components/modules/ClientDetail/Case/utils/mappers";
import Navigation from "../../../../../components/navigations/client/detail/case/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import useService from "../../../../../hooks/useService";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case, _caseHistory } = useParentLoaderData(2);
  const mappedCase = propertyDamageTabDataMapper(_case);
  const currentUserService = inject("current-user-service");
  const caseRepository = useService("repositories/case-repository");
  const userPermissions = currentUserService?.userRoles?.permissions || [];
  const canEdit = userPermissions.includes("casemanager.change_case");
  const canView = userPermissions.includes("casemanager.view_case");
  const mappedLayout = mapPermissions(propertyDamageLayout, canEdit);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/case/property-damage");
  }, []);

  return (
    <Navigation activeTab="property-damage" _case={_case}>
      {canView ? (
        <DynamicForm
          formLayout={mappedLayout}
          data={mappedCase}
          historyData={_caseHistory}
          formRepository={caseRepository}
        />
      ) : (
        <InvalidContent />
      )}
    </Navigation>
  );
};
